import { toRGBA } from "./utils";

const tomcat = [226, 226, 226];
const t = (opacity: number = 1) =>
  toRGBA(tomcat[0], tomcat[1], tomcat[2], opacity);

export default t;
